"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leadToServer = void 0;

function leadToServer(lead, source, projectSlug) {
  return {
    project_slug: projectSlug,
    lead: {
      email: lead.email,
      first_name: lead.firstName,
      last_name: lead.lastName,
      purchase_goal: lead.purchaseGoal,
      heard_from: lead.heardFrom,
      unit_features: lead.unitFeatures,
      typologies: lead.typologies,
      minimum_budget: lead.minimumBudget,
      maximum_budget: lead.maximumBudget,
      minimum_surface: lead.minimumSurface,
      maximum_surface: lead.maximumSurface,
      source: source,
      message: lead.message,
      phone: lead.phone
    }
  };
}

exports.leadToServer = leadToServer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin-leads/lib/utils.js
// module id = 865
// module chunks = 0